module.exports = __webpack_public_path__ + "static/media/14UNEP15.ade1430b.jpg";